const aaa = {
    state: {
      scoresQuery:{},
    },
    mutations: {
        saveQuery: (state, item) => {
         state.scoresQuery=item
      },
    },
    actions: {
        saveQuery({ commit }, item){
        commit('saveQuery', item)
      },
    }
  }
  
  export default aaa
  